import ApiService from "../../../services/api.service";

const itemValuesService = {

	getMinValuesList(data) {
		return ApiService.post(`item/list/min-values`, data)
	},
	getMaxValuesList(data) {
		return ApiService.post(`item/list/max-values`, data)
	},
	getItemValuesCounts() {
		return ApiService.get(`item/list/max-min-values`)
	}

}

export default itemValuesService;
